class TabsNew {
  constructor(container, cb = (() => {})) {
    this.selectors = {
      tabHeaders: [".cv-tab-header"],
      tabContents: [".cv-tab-content"],
      tabContentsExtra: [".m-tab-content-second"],
      colorCards: [".cv-color-card"],
      imageContainers: [".cv-image-container"],
      imageItems: [".cv-image-item"],
      arrowPrev: [".cv-arrow-left"],
      arrowNext: [".cv-arrow-right"],
    };
    this.activeClass = "active";
    this.currentActiveIndex = -1;
    this.currentTab = null;
    this.container = container;
    this.cb = cb;

    this.domNodes = queryDomNodes(this.selectors, container);
    this.customSelect = this.container.querySelector("m-select-component");

    // Make wrapper keyboard-focusable for ArrowLeft/ArrowRight
    if (!this.container.hasAttribute("tabindex")) this.container.setAttribute("tabindex", "0");

    this.init();
    this.setActiveTab(0);
  }

  init() {
    // Click on tab headers
    addEventDelegate({
      context: this.container,
      selector: this.selectors.tabHeaders[0],
      handler: (evt, target) => {
        evt.preventDefault();
        if (!target) return;
        const idx = Number(target.dataset.index);
        this.setActiveTab(idx);
        this.cb(target);
      },
    });

    // Click on color cards (image reveal)
    addEventDelegate({
      context: this.container,
      selector: this.selectors.colorCards[0],
      handler: (evt, target) => {
        evt.preventDefault();
        const pane = target.closest(".m-tab-content-second");
        if (!pane) return;
        const tabIdx = Number(pane.dataset.index || 0);
        const imgIdx = Number(target.dataset.imageIdx || 0);
        this.revealImage(tabIdx, imgIdx);
      },
    });

    // Arrow: NEXT
    addEventDelegate({
      context: this.container,
      selector: this.selectors.arrowNext[0],
      handler: (evt) => {
        evt.preventDefault();
        this.next();
      },
    });

    // Arrow: PREV
    addEventDelegate({
      context: this.container,
      selector: this.selectors.arrowPrev[0],
      handler: (evt) => {
        evt.preventDefault();
        this.prev();
      },
    });

    // Keyboard support
    this.container.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") { e.preventDefault(); this.next(); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); this.prev(); }
    });
  }

  getTabCount() {
    const headers = this.domNodes.tabHeaders || [];
    const contents = this.domNodes.tabContents || [];
    return Math.max(headers.length, contents.length);
  }

  next() { this.move(1); }
  prev() { this.move(-1); }

  move(delta) {
    const count = this.getTabCount();
    if (!count) return;
    const cur = (this.currentActiveIndex >= 0) ? this.currentActiveIndex : 0;
    const next = (cur + delta + count) % count; // why: wrap around seamlessly
    this.setActiveTab(next);
  }

  setActiveTab(index) {
    const { tabHeaders: headers, tabContents: panes, tabContentsExtra: extras } = this.domNodes;

    if (!panes.length) return;
    if (index === -1 || index === this.currentActiveIndex) return;

    let prevHeader, nextHeader, nextPane, prevExtra, nextExtra;
    prevHeader = headers && headers[this.currentActiveIndex];
    nextHeader = headers && headers[index];

    // Sync custom select if present
    if (this.customSelect && nextHeader) {
      if (this.customSelect.dataset.tabHeader === "select") {
        this.customSelect.updateCustomSelectChecked(index, nextHeader.innerHTML);
      }
      if (MinimogTheme.config.mqlMobile) {
        this.customSelect.updateCustomSelectChecked(index, nextHeader.innerHTML);
      }
      document.addEventListener("matchMobile", () =>
        this.customSelect.updateCustomSelectChecked(index, nextHeader.innerHTML)
      );
    }

    nextPane = panes && panes[index];
    prevExtra = extras && extras[this.currentActiveIndex];
    nextExtra = extras && extras[index];

    if (prevHeader) prevHeader.classList.remove(this.activeClass);
    if (this.currentTab) this.currentTab.classList.remove(this.activeClass);
    if (prevExtra) prevExtra.classList.remove(this.activeClass);

    if (nextHeader) nextHeader.classList.add(this.activeClass);
    if (nextPane) nextPane.classList.add(this.activeClass);
    if (nextExtra) nextExtra.classList.add(this.activeClass);

    // fade guarded to avoid layout thrash
    setTimeout(() => { if (nextPane) nextPane.style.opacity = 1; });
    setTimeout(() => { if (nextExtra) nextExtra.style.opacity = 1; });

    this.currentActiveIndex = index;
    this.currentTab = nextPane;

    // Show the first image in the newly activated tab
    this.revealImage(index, 0);
  }

  revealImage(tabIdx, imgIdx) {
    const blocks = this.container.querySelector(".m-collage-tabs__blocks");
    if (!blocks) return;
    const pane = blocks.querySelector(`.cv-tab-content[data-index="${tabIdx}"]`);
    if (!pane) return;
    const container = pane.querySelector(this.selectors.imageContainers[0]);
    if (!container) return;
    const items = container.querySelectorAll(this.selectors.imageItems[0]);
    items.forEach((el) => el.classList.remove("is-active"));
    const target = container.querySelector(`${this.selectors.imageItems[0]}[data-idx="${imgIdx}"]`);
    if (target) target.classList.add("is-active");
  }
}

window.MinimogTheme = window.MinimogTheme || {};
window.MinimogTheme.TabsNew = TabsNew;

if (!customElements.get("tcw-tabs-component")) {
  class CVTabs extends HTMLElement {
    constructor() {
      super();
      this.selectors = { tabWrapper: ".m-collage-tabs__wrapper" };
      this.domNodes = queryDomNodes(this.selectors, this);
      this.init();
    }
    connectedCallback() {
      this.tabs.setActiveTab(0);
    }
    init = () => {
      this.tabs = new MinimogTheme.TabsNew(this.domNodes.tabWrapper);

      // Shopify editor support
      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => {
          if (e.target.classList.contains("cv-tab-content")) {
            const idx = e.target.dataset.index;
            this.tabs.setActiveTab(Number(idx));
          }
        });
        document.addEventListener("shopify:block:select", (e) => {
          if (e.target.classList.contains("m-tab-content-second")) {
            const idx = e.target.dataset.index;
            this.tabs.setActiveTab(Number(idx));
          }
        });
      }
    };
  }
  customElements.define("tcw-tabs-component", CVTabs);
}